<template>
  <v-container>
    <v-progress-linear
      :value="vocabularyScore+1 === Object.keys(vocabularies).length ? 100 : progress * 100"
      color="amber"
      rounded
      height="25">
      <div
        class="subtitle-2 font-weight-light"
        style="position: absolute; left: 5px;">
        Nb: {{ vocabularyScore + 1 }} / {{ Object.keys(vocabularies).length }}
      </div>
    </v-progress-linear>
    <v-carousel
      light
      hide-delimiters
      :show-arrows="false"
      touchless
      v-model="slide">
      <v-carousel-item v-for="(vocabulary, index) in vocabularies" :key="index">
        <VocabularyContainer
          :vocabulary="vocabulary"
          @next:slide="nextSlide"
          @prev:slide="prevSlide"
          :first-slide="firstSlide"
          :last-slide="lastSlide" />
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VocabularyContainer from './vocabulary_container';

export default {
  name: 'VocabularyManager',
  components: {
    VocabularyContainer,
  },
  data: () => ({
    slide: 0,
  }),
  computed: {
    ...mapGetters('current', ['vocabularyScore']),
    ...mapGetters('vocabularies', ['vocabularyList']),

    vocabularies() {
      return this.vocabularyList.vocabularies;
    },
    firstSlide() {
      return this.slide === 0;
    },
    lastSlide() {
      return this.slide === this.vocabularies.length - 1;
    },
    progress() {
      return this.vocabularyScore / Object.keys(this.vocabularies).length;
    },
  },
  methods: {
    ...mapActions('current', ['setVocabularyScore']),

    nextSlide() {
      this.slide += 1;
      this.setVocabularyScore(this.vocabularyScore + 1);
    },
    prevSlide() {
      this.slide -= 1;
      this.setVocabularyScore(this.vocabularyScore - 1);
    },
  },
};
</script>
